// To be able to request the Staging API from Local to increase development efficiency
export const STAGING_API_ENDPOINT =
  'https://app.staging.president-card.com/api/bank'
